module.exports = __webpack_public_path__ + "images/category_lp/watch/omega/main-view_b97ff0bb183d54733ae7a5647c3193bf.png";